var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react-day-picker';
import { Select } from '../../../../forms/components/select';
import { DropdownSelect } from '../styles';
/**
 * Render a dropdown component to use in the navigation bar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Dropdown(props) {
    const { options } = props, selectProps = __rest(props, ["options"]);
    return (_jsx(DropdownSelect, Object.assign({ reference: "date-picker-dropdown", name: "date-picker-dropdown" }, selectProps, { color: undefined, colorContext: "on-medium", children: options === null || options === void 0 ? void 0 : options.filter(({ disabled }) => !disabled).map(({ value, label, disabled }) => (_jsx(Select.Option, { value: value, disabled: disabled, children: label }, value))) })));
}
